import { render, staticRenderFns } from "./LoginTablet.vue?vue&type=template&id=4024ae6f&scoped=true"
import script from "./LoginTablet.vue?vue&type=script&lang=js"
export * from "./LoginTablet.vue?vue&type=script&lang=js"
import style0 from "./LoginTablet.vue?vue&type=style&index=0&id=4024ae6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024ae6f",
  null
  
)

export default component.exports